import React from 'react'
import PropTypes from 'prop-types'

import './ChatLogo.scss'

const ChatLogo = ({ online, width, height }) => {
  const onlineClass = online ? 'online' : 'offline'

  return (
    <div className='chat-logo' style={{ width, height }}>
      <span className={`chat-logo__indicator chat-logo__indicator--${onlineClass}`} />
      <svg
        className='chat-logo__svg'
        width='177'
        height='152'
        viewBox='0 0 177 152'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        style={{ width, height, borderRadius: width }}
      >
        <polygon fill='#D42114' points='0.524 151.656 176.791 151.656 176.791 0.898 0.524 0.898' />
        <g id='Logo' transform='scale(0.75), translate(35,30)'>
          <path fill='#FFFFFE' d='M77.394,74.308 C77.394,74.308 94.758,45.389 101.971,36.286 C101.971,36.286 102.602,35.516 102.811,36.286 L104.492,74.308 L77.394,74.308 Z M125.966,107.758 C125.966,107.758 121.672,24.383 121.483,19.619 C121.298,14.858 116.722,14.858 116.722,14.858 L105.706,14.858 C95.81,14.858 93.195,18.967 93.195,18.967 C75.268,39.976 36.896,106.637 36.896,106.637 C35.542,110.394 39.019,110.861 39.019,110.861 L55.266,110.861 C58.275,110.861 59.747,107.641 59.747,107.641 L69.551,90.975 L104.212,90.975 C104.212,90.975 104.771,105.189 104.91,107.991 C105.053,110.793 108.272,110.861 108.272,110.861 L122.559,110.861 C126.199,110.861 125.966,107.758 125.966,107.758 Z' />
          <path fill='#FFFFFE' d='M38.016,118.869 C38.016,118.869 72.376,138.383 121.765,118.869 C121.765,118.869 123.49,118.307 124.287,119.055 C125.08,119.803 124.613,120.314 123.772,120.922 C122.932,121.528 80.123,153.435 35.519,120.666 C35.519,120.666 34.702,119.771 35.729,118.664 C35.729,118.664 36.474,118.08 38.016,118.869' />
        </g>
      </svg>
    </div>
  )
}

ChatLogo.propTypes = {
  online: PropTypes.bool.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
}

ChatLogo.defaultProps = {
  width: 46,
  height: 46
}

export default ChatLogo
